import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { Envelope } from '../stripeFeesQuery/types';
import { responseHandler } from '../utils';
import { BackfillGuestModulesParams, GuestModulesBackfillRun } from './types';

/**
 * Uruchamia backfill lustra `guestModules`. Bez `hotelId` przelicza wszystkie
 * hotele, z `hotelId` tylko jeden. Payload backendu leży pod `response.data.data`
 * (koperta `{ success, message, data }`).
 */
export const useBackfillGuestModules = (
  options?: UseMutationOptions<GuestModulesBackfillRun, AxiosError, BackfillGuestModulesParams>,
): UseMutationResult<GuestModulesBackfillRun, AxiosError, BackfillGuestModulesParams> => useMutation<
  GuestModulesBackfillRun,
  AxiosError,
  BackfillGuestModulesParams
>({
  mutationFn: async ({ hotelId } = {}) => {
    const body = hotelId ? { hotelId } : {};
    const response = await axiosInstance.post<Envelope<GuestModulesBackfillRun>>(
      '/v3-backfillGuestModules',
      body,
    );
    return responseHandler(response).data;
  },
  ...options,
});
